export default {
  // httpURL: 'http://192.168.40.136:8050/lfnsmsplatform/',
  // httpURL: "http://192.168.40.101:8050/lfnsmsplatform",
  httpURL: "https://sms.yizl.net/lfnsmsplatform",
}



// WEBPACK FOOTER //
// ./src/server/http.js